// /**
//  * Partner - Add User
//  */

// React
import React, {useEffect, useState} from 'react';

// Components
import ListUser from './list-users';
import RenderFilter from '../../utils/listDaynamicFilter';

// Helper
import {removeEmptyValueObject, UserRoles} from '../../utils/helpers';

// Type
import {PayloadUpdate} from './interfaces';
import {User} from '../users/interfaces';
import type {Filter} from '../../utils/listDaynamicFilter';

type Props = {
  usersList: User[];
  partnerId: number;
  handleClose: () => void;
  usersBeAdminPartnerDispatch: (payload: any) => void;
  updatePartnerDispatch: (payload: PayloadUpdate) => void;
};

export default function Add(props: Props) {
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({} as any);

  useEffect(() => {
    getUsersBeAdminPartner();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const getUsersBeAdminPartner = () => {
    props.usersBeAdminPartnerDispatch({
      ...removeEmptyValueObject(filtersValues),
      'partnersId.specified': false,
    });
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام کاربر',
      },
      {
        type: 'input',
        id: 'phoneNumber.contains',
        label: 'شماره همراه کاربر',
      },
      {
        type: 'number',
        id: 'id.equals',
        label: 'کد کاربر',
      },
      {
        type: 'checkbox',
        id: 'role.in',
        label: 'نقش کاربر',
        data: UserRoles,
        translateType: 'UserRole'
      },
    ]);
  };

  return (
    <>
      <RenderFilter
        filters={filters}
        onFilter={(filtervalues: any) => {
          setFiltersValues({
            ...removeEmptyValueObject(filtervalues),
            page: 0,
            size: 10,
          });
        }}
      />

      <ListUser
        partnerId={props.partnerId}
        data={props.usersList}
        hasSelectUser
        updatePartnerDispatch={props.updatePartnerDispatch}
        handleClose={props.handleClose}
      />
    </>
  );
}
